import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { REGEX } from "../../constants";

@Component({
	selector: 'app-password-field',
	templateUrl: './password-field.component.html',
	styleUrls: ['./password-field.component.scss']
})
export class PasswordFieldComponent implements OnInit {
	@Input() passwordFieldTitle: string = '';
	@Input() confirmFieldTitle: string = '';
	@Output() password = new EventEmitter<string>();
	@Output() passwordValid = new EventEmitter<boolean>();

	form;
	passwordVisible = false;
	confirmPasswordVisible = false;
	passwordOK: boolean = false;
	passwordHasSpecial: boolean = false;
	passwordHasNumber: boolean = false;
	passwordHasCapital: boolean = false;
	passwordHasLower: boolean = false;
	passwordContainsSpace: boolean = false;
	passwordToShort: boolean = false;
	passwordsMatch: boolean = false;
	passwordRegex = REGEX.PASSWORD;
	digitsRegex = REGEX.DIGITS;
	specialCharacterRegex = REGEX.SPECIAL_CHARACTERS_WITHOUT_SPACE_HYPHEN;
	uppercaseRegex = REGEX.UPPERCASE_LETTERS;
	lowercaseRegex = REGEX.LOWERCASE_LETTERS;
	spaceRegex = REGEX.SPACES;
	passwordValidation:string

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit(): void {
		this.form = this.formBuilder.group( {
			password: ["",Validators.required],
			confirmPassword: ["",Validators.required]
		} );

		this.form.get('password').valueChanges.subscribe(value => {
				const passwordControl = this.form.get('password');
		
				if (!value) {
					passwordControl.setErrors({ required: true });
				} else {
					this.passwordOK = value && value.match(this.passwordRegex);
					this.passwordHasSpecial = this.specialCharacterRegex.test(value);
					this.passwordHasCapital = this.uppercaseRegex.test(value);
					this.passwordHasNumber = this.digitsRegex.test(value);
					this.passwordContainsSpace = this.spaceRegex.test(value);
					this.passwordHasLower = this.lowercaseRegex.test(value);
					this.passwordToShort = value.length >7;
					
					if (!this.passwordHasCapital || !this.passwordHasLower || !this.passwordHasSpecial || !this.passwordHasNumber || this.passwordContainsSpace || !this.passwordToShort) {
						passwordControl.setErrors({ 'passwordNotValid': true });
					}else {
						passwordControl.setErrors(null);
					}
				} 

				this.passwordValid.emit(this.passwordOK && this.passwordsMatch);
			});
        
		this.form.get('confirmPassword').valueChanges.subscribe(value => {
			const confirmPasswordControl = this.form.get('confirmPassword');
			if(value==='')
			{
				this.passwordValidation='';
			}
			else if(value && (this.form.value['password'] === value))
			{
				this.passwordsMatch=true;
				confirmPasswordControl.setErrors(null);
			}
			else
			{
				this.passwordsMatch=false;
				confirmPasswordControl.setErrors({'confirmPasswordNotMatch':true})
			}
			//this.passwordsMatch = value && (this.form.value['password'] === value) ;
			this.password.emit(this.form.value['password']);
			this.passwordValid.emit(this.passwordOK && this.passwordsMatch);
		});
		this.form.get('password').valueChanges.subscribe(value => {
			if(value==='')
			{
				this.passwordValidation='';
			}
			else if(value && (this.form.value['confirmPassword'] === value))
			{
				this.passwordsMatch=true;
				this.passwordValidation= 'global.password_validation.match';
			}
			else
			{
				this.passwordsMatch=false;
				this.passwordValidation= 'global.password_validation.no_match';
			}
			//this.passwordsMatch = value && (this.form.value['password'] === value) ;
			this.password.emit(this.form.value['password']);
			this.passwordValid.emit(this.passwordOK && this.passwordsMatch);
		});
	}

	reset() {
		this.form.controls['password'].setValue("");
		this.form.controls['confirmPassword'].setValue("");
	}
}
